
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// Composable
import useNotifications from '@/common/composable/useNotifications'

// realisations
import { dispatcher } from '@/core/realisations/dispatcher.realisation'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
        'file-reader': FileReader,
    },
    emits: ['cancel', 'submited'],
    props: {
        deliveryId: {
            type: Number,
            required: true,
        },
    },
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: false,
            receiver_name: null as string | null,
            files: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                receiver_name: { required },
                files: { required },
            },
            state
        )

        const emitCancel = () => {
            emit('cancel')
        }

        const emitSubmited = () => {
            emit('submited')
        }

        const approveDelivery = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            if (!state.receiver_name) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('delivery_receiver_name', state.receiver_name)

                for (const file of state.files) {
                    form_data.append('attachments[]', file)
                }

                await dispatcher.approveDelivery(props.deliveryId, form_data)

                state.is_failed = false
                emitSubmited()
            } catch (error) {
                state.is_failed = true

                notifications.notifyError({
                    error,
                    title: 'При закрытии доставки произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmited,
            approveDelivery,
        }
    },
})
